function manageEmployeeFn(form) {
    const btnRaise = document.querySelector('.btn-raise');
    const btnFire = document.querySelector('.btn-fire');
    const submitBtn = document.querySelector('.btn-su');

    if (!btnRaise || !btnFire) {
        return;
    }

    btnRaise.addEventListener('click', () => {
        const actionInput = form.querySelector('input[name="action"]');
        actionInput.value = 'raise';
        submitBtn.click();
    });

    btnFire.addEventListener('click', () => {
        const actionInput = form.querySelector('input[name="action"]');
        actionInput.value = 'fire';
        submitBtn.click();
    });
}